import { safeTransaction } from "../../helpers/db";
import { reqToEnableRestaurantDetailsIDBCheck } from "../../store/slice/indexedDBSlice";

export const insertRestaurantDetailsInDB = async (data, dispatch, type) => {
  try {
    const {
      reqObj,
      currSItem,
      currSubItem,
      currSRestaurant,
      selectedLocation,
    } = data;

    let addedDataID = "";
    await safeTransaction(
      ["restaurantDetails", "govermentMarketDetails", "addedRestaurantDetails"],
      async (tx) => {
        const restaurantDetailsTable = tx.table("restaurantDetails");
        const addedRestaurantDetails = tx.table("addedRestaurantDetails");
        const govermentMarketDetails = tx.table("govermentMarketDetails");

        let restaurantDetails = null;

        if (type === "COMPANY") {
          restaurantDetails = await restaurantDetailsTable.get(
            currSRestaurant?.id
          );
        } else if (type === "GOVERMENT") {
          restaurantDetails = await govermentMarketDetails.get(
            currSRestaurant?.id
          );
        }

        if (restaurantDetails === null) return;

        if (reqObj?.status === "skip") {
          const createSkipItemObj = [reqObj];
          while (createSkipItemObj?.length < 3) {
            createSkipItemObj.push(reqObj);
          }

          const updatedLocation = restaurantDetails?.location?.map((loc) => {
            if (loc.name !== selectedLocation) return loc;
            return {
              ...loc,
              items: loc.items.map((item) => {
                if (item.id !== currSItem.id) return item;
                return {
                  ...item,
                  sub_items: item.sub_items.map((sub) => {
                    if (sub.id !== currSubItem.id) return sub;
                    return {
                      ...sub,
                      item_report: Array.isArray(sub.item_report)
                        ? [...sub.item_report, ...createSkipItemObj]
                        : [...createSkipItemObj],
                    };
                  }),
                };
              }),
            };
          });

          const updatedRestaurantDetails = {
            ...restaurantDetails,
            location: updatedLocation,
          };

          addedDataID = await addedRestaurantDetails.add(reqObj);
          if (type === "COMPANY") {
            await restaurantDetailsTable.put({ ...updatedRestaurantDetails });
          } else if (type === "GOVERMENT") {
            await govermentMarketDetails.put({ ...updatedRestaurantDetails });
          }
        } else {
          const updatedLocation = restaurantDetails?.location?.map((loc) => {
            if (loc.name !== selectedLocation) return loc;
            return {
              ...loc,
              items: loc.items.map((item) => {
                if (item.id !== currSItem.id) return item;
                return {
                  ...item,
                  sub_items: item.sub_items.map((sub) => {
                    if (sub.id !== currSubItem.id) return sub;
                    return {
                      ...sub,
                      item_report: Array.isArray(sub.item_report)
                        ? [...sub.item_report, reqObj]
                        : [reqObj],
                    };
                  }),
                };
              }),
            };
          });

          const updatedRestaurantDetails = {
            ...restaurantDetails,
            location: updatedLocation,
          };

          addedDataID = await addedRestaurantDetails.add(reqObj);
          if (type === "COMPANY") {
            await restaurantDetailsTable.put({ ...updatedRestaurantDetails });
          } else if (type === "GOVERMENT") {
            await govermentMarketDetails.put({ ...updatedRestaurantDetails });
          }
        }
        dispatch(reqToEnableRestaurantDetailsIDBCheck({}));
      }
    );
    return addedDataID;
  } catch (error) {
    throw error;
  }
};

export const insertRestaurantNotesInDB = async (data, dispatch, type) => {
  try {
    const {
      reqObj,
      currSItem,
      currSubItem,
      currSRestaurant,
      selectedLocation,
    } = data;

    let addedDataID = "";
    await safeTransaction(
      [
        "restaurantDetails",
        "govermentMarketDetails",
        "addedRestaurantTaskNotes",
      ],
      async (tx) => {
        const restaurantDetailsTable = tx.table("restaurantDetails");
        const govermentMarketDetails = tx.table("govermentMarketDetails");
        const addedRestaurantNotesTable = tx.table("addedRestaurantTaskNotes");

        let restaurantDetails = null;

        if (type === "cReports" || type === "COMPANY") {
          restaurantDetails = await restaurantDetailsTable.get(
            currSRestaurant?.id
          );
        } else if (type === "gReports" || type === "GOVERMENT") {
          restaurantDetails = await govermentMarketDetails.get(
            currSRestaurant?.id
          );
        }

        if (restaurantDetails === null) return;

        const updatedLocation = restaurantDetails?.location?.map((loc) => {
          if (loc.name !== selectedLocation) return loc;
          return {
            ...loc,
            items: loc.items.map((item) => {
              if (item.id !== currSItem.id) return item;
              return {
                ...item,
                sub_items: item.sub_items.map((sub) => {
                  if (sub.id !== currSubItem.id) return sub;
                  return {
                    ...sub,
                    notes: reqObj?.notes,
                    attachments: reqObj?.attachments,
                    base64: reqObj?.base64,
                  };
                }),
              };
            }),
          };
        });

        const updatedRestaurantDetails = {
          ...restaurantDetails,
          location: updatedLocation,
        };

        addedDataID = await addedRestaurantNotesTable.add(reqObj);
        if (type === "cReports" || type === "COMPANY") {
          await restaurantDetailsTable.put({ ...updatedRestaurantDetails });
        } else if (type === "gReports" || type === "GOVERMENT") {
          await govermentMarketDetails.put({ ...updatedRestaurantDetails });
        }

        await dispatch(reqToEnableRestaurantDetailsIDBCheck({}));
      }
    );
    return addedDataID;
  } catch (error) {
    throw error;
  }
};
